/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContactFinanceSummaryDto } from '../models/work-contact-finance-summary-dto';

@Injectable({ providedIn: 'root' })
export class WorkContactsFinanceV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsFinanceV2ControllerGetFinanceSummary()` */
  static readonly ContactsFinanceV2ControllerGetFinanceSummaryPath = '/v2/contacts-finance/{contactId}/summary';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsFinanceV2ControllerGetFinanceSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsFinanceV2ControllerGetFinanceSummary$Response(
    params: {
      contactId: number;

    /**
     * Überschreibt die Containertype-Config REPORT_DECKUNGSBEITRAG_INCLUDE_MONTAGEAUFWAND_BOOLEAN. Ohne Wert entscheidet die Config pro Containertype (Grundstellung des Toggles im Frontend).
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactFinanceSummaryDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsFinanceV2Service.ContactsFinanceV2ControllerGetFinanceSummaryPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
      rb.query('includeMontageaufwand', params.includeMontageaufwand, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactFinanceSummaryDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsFinanceV2ControllerGetFinanceSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsFinanceV2ControllerGetFinanceSummary(
    params: {
      contactId: number;

    /**
     * Überschreibt die Containertype-Config REPORT_DECKUNGSBEITRAG_INCLUDE_MONTAGEAUFWAND_BOOLEAN. Ohne Wert entscheidet die Config pro Containertype (Grundstellung des Toggles im Frontend).
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkContactFinanceSummaryDto> {
    return this.contactsFinanceV2ControllerGetFinanceSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactFinanceSummaryDto>): WorkContactFinanceSummaryDto => r.body)
    );
  }

}
